import { PlayerPageWrapper } from 'src/common/components/player-page-wrapper/player-page-wrapper';
import { UpgradeModal } from 'src/dashboard/components/upgrade-modal/upgrade-modal';

type VideoAnalyticsPageProps = {
  params: {
    shortcode: string;
  };
};

const VideoAnalyticsPage = ({
  params: { shortcode },
}: VideoAnalyticsPageProps) => {
  return (
    <>
      <PlayerPageWrapper
        page={`/videos/${shortcode}/analytics`}
        title={`Video analytics summary for ${shortcode}`}
      />
      <UpgradeModal />
    </>
  );
};

export default VideoAnalyticsPage;
